import { z } from "zod";

export const launchWorkflowIdSchema = z
  .enum(["ad-to-lander", "competitor-teardown"])
  .describe("LaunchWorkflowId");
export const workflowPublicInputsSchema = z
  .object({
    sourceUrl: z.string().max(2048).default(""),
    productDescription: z.string().max(1000).default(""),
    conversionGoal: z.string().max(300).default("Add to cart"),
  })
  .strict()
  .describe("WorkflowPublicInputs");
export const workflowLaunchInputsSchema = workflowPublicInputsSchema
  .extend({
    productId: z.uuid().nullable().default(null),
  })
  .describe("WorkflowLaunchInputs");
export const workflowContinuationCreateSchema = z
  .object({
    workflowId: launchWorkflowIdSchema,
    definitionVersion: z.literal(1),
    inputs: workflowPublicInputsSchema,
    resumeStepId: z
      .enum(["source", "product", "goal"])
      .nullable()
      .default(null),
  })
  .strict()
  .describe("WorkflowContinuationCreate");
export const workflowContinuationSchema = workflowContinuationCreateSchema
  .extend({
    id: z.uuid(),
    userId: z.string().nullable(),
    projectId: z.uuid().nullable(),
    revision: z.number().int().nonnegative(),
    inputs: workflowLaunchInputsSchema,
    sessionId: z.string().nullable(),
    expiresAt: z.number(),
  })
  .describe("WorkflowContinuation");
export type WorkflowContinuation = z.infer<typeof workflowContinuationSchema>;
